import React from 'react';
import PropTypes from 'prop-types';

import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Dialog from 'Components/UI/Dialog';
import useMobileLayout from 'Hooks/useMobileLayout';
import DialogContainer from './DialogContainer';

const styles = () => ({
  paper: {
    width: '100%',
  },
});

const AccountTransferDialog = ({
  classes,
  isOpen,
  closeModal,
  accountTransferResource,
}) => {
  const isMobile = useMobileLayout();

  return (
    <Dialog
      classes={classes}
      fullScreen={isMobile}
      onClose={closeModal}
      open={isOpen}
      variant="modern"
      maxWidth="xs"
      primaryHeader
      title={accountTransferResource?.attr('transferTitle') || 'Account Transfer'}
    >
      <DialogContainer
        closeModal={closeModal}
        accountTransferResource={accountTransferResource}
      />
    </Dialog>
  );
};

AccountTransferDialog.propTypes = {
  classes: PropTypes.object.isRequired,
  isOpen: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
  accountTransferResource: PropTypes.object.isRequired,
};

export default withStyles(styles)(AccountTransferDialog);
